import { type MessageDescriptor } from 'react-intl'

import messages from './messages'

export const SUGGESTED_PROMPT_MESSAGES: MessageDescriptor[] = [
  messages.restockOfficeSupplies,
  messages.orderSafetyGear,
  messages.orderCleaningSupplies,
]
